// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { LotteryKind } from "../../lottery/common/data/LotteryKind";
import LotterySelectItem from "./LotterySelectItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LotterySelectLayer extends BasePopUpLayer {

    @property({ type: cc.Button, displayName:'' })
	btnArrowRight: cc.Button = null;

	@property({ type: cc.Button, displayName:'' })
	btnArrowLeft: cc.Button = null;

    @property({ type: cc.PageView, displayName:'' })
	pageView: cc.PageView = null;

	@property({ type: cc.Node, displayName:'' })
	nodeLayout: cc.Node = null;

    @property(cc.Prefab)
    prefabItem: cc.Prefab = null;

    private pageCount = 0;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();

        O1HD.on(MessageEventKind.EventName.UPDATE_LOTTERY_LIST, this.updateLotteryList, this);
    }

    initLayer() {
        this.pageView.removeAllPages();
        this.nodeLayout.active = false;
        this.nodeLayout.removeAllChildren();

        let max_count = 6;
        let pageCount = 0;
        let curNodeItem: cc.Node = null;
        let list = LotteryKind.LotteryList;
        for (let i = 0; i < list.length; i++) {
            let o = list[i];

            if ((i % max_count) == 0) {
                pageCount++;
                let nodeItem = cc.instantiate(this.nodeLayout);
                nodeItem.active = true;
                curNodeItem = nodeItem;
                this.pageView.addPage(nodeItem);
                // this.pageView.content.addChild(nodeItem);
            }

            let nodeItem = cc.instantiate(this.prefabItem);
            curNodeItem.addChild(nodeItem);

            let script = nodeItem.getComponent(LotterySelectItem);
            script.setData(o, this);
        }
        this.pageCount = pageCount;
        this.refreshPageState();
    }

    updateLotteryList() {
        this.initLayer();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    refreshCurPageLabel() {
        let curIdx = this.pageView.getCurrentPageIndex();
        // this.labelNum.string = (curIdx+1) + '/' + this.pageCount;
    }

    refreshPageState() {
        this.refreshCurPageLabel();

        let pages = this.pageView.getPages();
        let curIdx = this.pageView.getCurrentPageIndex();
        let count = pages.length;

        this.btnArrowRight.interactable = true;
        this.btnArrowLeft.interactable = true;
        this.btnArrowRight.node.active = true;
        this.btnArrowLeft.node.active = true;
        if (curIdx == 0) {
            this.btnArrowLeft.interactable = false;
            this.btnArrowLeft.node.active = false;
        } 
        if (curIdx == count - 1) {
            this.btnArrowRight.interactable = false;
            this.btnArrowRight.node.active = false;
        }
    }

    onClickLeftPage() {
        let curIdx = this.pageView.getCurrentPageIndex();
        this.pageView.scrollToPage(curIdx-1, 0.45);
    }

    onClickRightPage() {
        let curIdx = this.pageView.getCurrentPageIndex();
        this.pageView.scrollToPage(curIdx+1, 0.45);
    }

    pageViewCallback(pageView: cc.PageView) {
        this.refreshPageState();
    }

    // update (dt) {}
}
 